import { Link } from 'react-router-dom';

const links = [
  { path: '/retour-affectif-guadeloupe', label: 'Retour affectif en Guadeloupe', id: 'retour-affectif' },
  { path: '/voyance-guadeloupe', label: 'Voyance en Guadeloupe', id: 'voyance' },
  { path: '/desenvoutement-guadeloupe', label: 'Désenvoûtement en Guadeloupe', id: 'desenvoutement' },
];

export const ServiceLinks = () => (
  <nav data-testid="restored-service-links" aria-label="Autres consultations" className="restored-service-links">
    {links.map(({ path, label, id }) => (
      <Link data-testid={`related-service-${id}`} key={path} to={path}>{label}</Link>
    ))}
  </nav>
);